import { Skeleton } from '@fff-web/fff-ui-shared';
import * as styles from './KeepSubscriptions.module.scss';

const ProductSkeleton = () => (
  <div className={styles.productSkeleton}>
    <Skeleton animation="wave" />
    <Skeleton animation="wave" />
    <Skeleton animation="wave" />
  </div>
);

const KeepSubscriptionsLoadingFallback = () => (
  <div className={styles.productsContainer}>
    <ProductSkeleton />
    <ProductSkeleton />
    <ProductSkeleton />
    <ProductSkeleton />
    <ProductSkeleton />
  </div>
);

export { KeepSubscriptionsLoadingFallback };
